// extracted by mini-css-extract-plugin
export default {"primaryColor":"#158e10","primaryColorWithAlpha":"rgba(21,142,16,.1019607843)","mainBgColor":"#0f0f0f","secondBgColor":"#0f0f0f","blackColor2":"#1f1f1f"};